module.exports = require('./helpers/bundle-url').getBundleURL('5wSQ1') + "logo-dark.eefe0b7f.svg";